module.exports = __webpack_public_path__ + "static/media/pres1.db6d341d.png";